import { useEffect, useRef, useState } from "react";
import {
  TYPEWRITER_INITIAL_STATE,
  getNextTypewriterState,
  getTypewriterDelayMs,
  getTypewriterText,
} from "../utils/typewriterPlaceholder";

const EMPTY_PHRASES = [];

const useTypewriterPlaceholder = ({
  phrases = EMPTY_PHRASES,
  isPaused = false,
}) => {
  const [state, setState] = useState(TYPEWRITER_INITIAL_STATE);
  const hasStartedRef = useRef(false);
  const phrasesKey = phrases.join("\n");

  useEffect(() => {
    if (isPaused || phrases.length === 0) {
      return undefined;
    }
    const delayMs = getTypewriterDelayMs({
      state,
      isFirstRun: !hasStartedRef.current,
    });
    const timeoutID = window.setTimeout(() => {
      hasStartedRef.current = true;
      setState((current) =>
        getNextTypewriterState({ state: current, phrases })
      );
    }, delayMs);
    return () => window.clearTimeout(timeoutID);
    // phrasesKey stands in for phrases to avoid restarting on new array refs
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, isPaused, phrasesKey]);

  return getTypewriterText({ state, phrases });
};

export default useTypewriterPlaceholder;
